import { useMemo } from 'react';
import { useWindowSize } from 'rooks';

const tabletBreakpoint = 1024;
const mobileBreakpoint = 600;
export default () => {
  const { outerWidth } = useWindowSize();

  const data = useMemo(
    () => ({
      isDesktop: outerWidth > tabletBreakpoint,
      isTablet: outerWidth < tabletBreakpoint,
      isMobile: outerWidth < mobileBreakpoint,
    }),
    [outerWidth],
  );
  return data;
};
